import styled, { css } from 'styled-components';
import { suppressProps } from '../../utils/suppress-props.js';
export const InputElement = styled.input(({ theme }) => css `
    font-size: ${theme.fontSizes[theme.styles.uiText.input.fontSize]};
    font-weight: ${theme.fontWeights[theme.styles.uiText.input.fontWeight]};
    line-height: ${theme.lineHeights[theme.styles.uiText.input.lineHeight]};
    letter-spacing: ${theme.letterSpacings[theme.styles.uiText.input.letterSpacing]};
    text-decoration-style: ${theme.styles.uiText.input.textDecoration};
    background: ${theme.colors.transparent};
    padding: ${theme.space.x0};
    border: ${theme.borderStyles.none};
    outline: 0;
    flex-grow: 1;
    min-width: 0;

    &::placeholder {
      font-size: ${theme.fontSizes[theme.styles.uiText.placeholder.fontSize]};
      line-height: ${theme.lineHeights[theme.styles.uiText.placeholder.lineHeight]};
      font-weight: ${theme.fontWeights[theme.styles.uiText.placeholder.fontWeight]};
      letter-spacing: ${theme.letterSpacings[theme.styles.uiText.placeholder.letterSpacing]};
      text-decoration-style: ${theme.styles.uiText.placeholder.textDecoration};
    }
  `);
const getInputContainerInactiveStyles = ({ theme, }) => css `
  background: ${theme.styles.inputs.states.inactive.backgroundColor};

  ${InputElement} {
    color: ${theme.styles.inputs.states.inactive.color};
    &::placeholder {
      color: ${theme.styles.inputs.states.inactive.placeholder};
    }
  }
`;
const getInputContainerHoverStyles = ({ theme, }) => css `
  &:hover {
    background: ${theme.styles.inputs.states.hover.backgroundColor};

    ${InputElement} {
      color: ${theme.styles.inputs.states.hover.color};
      &::placeholder {
        color: ${theme.styles.inputs.states.hover.placeholder};
      }
    }
  }
`;
const getInputContainerActiveStyles = ({ theme, }) => css `
  &:focus-within {
    background: ${theme.styles.inputs.states.active.backgroundColor};
    outline: ${theme.outlines.input.rule};
    outline-offset: ${theme.outlines.input.offset};

    ${InputElement} {
      color: ${theme.styles.inputs.states.active.color};
      &::placeholder {
        color: ${theme.styles.inputs.states.hover.placeholderActive};
      }
    }
  }
`;
const getInputContainerErrorStyles = ({ theme, isErrored, }) => {
    if (isErrored)
        return css `
      border-color: ${theme.styles.inputs.states.error.borderColor};
    `;
    return css ``;
};
const getInputContainerDisabledStyles = ({ theme, isDisabled, }) => {
    if (isDisabled)
        return css `
      &:not(:hover),
      &:hover {
        cursor: not-allowed;
        background: ${theme.styles.inputs.states.disabled.backgroundColor};
        opacity: ${theme.styles.inputs.states.disabled.opacity};

        ${InputElement} {
          cursor: not-allowed;
          color: ${theme.styles.inputs.states.disabled.color};
          &::placeholder {
            color: ${theme.styles.inputs.states.disabled.placeholder};
          }
        }
      }
    `;
    return css ``;
};
const getInputContainerInactiveOnGrayStyles = ({ theme, isOnGray, }) => {
    if (isOnGray)
        return css `
      background: ${theme.colors.controls.secondaryOnGray};
      ${InputElement} {
        &::placeholder {
          color: ${theme.styles.inputs.states.inactive.placeholderOnGray};
        }
      }
    `;
    return css ``;
};
export const InputContainerElement = styled.div.withConfig(suppressProps('isErrored', 'isDisabled', 'isOnGray', 'fullWidth'))(({ theme, fullWidth }) => css `
      display: flex;
      align-items: center;
      height: ${theme.styles.inputs.base.minHeight};
      border-style: ${theme.styles.inputs.base.borderStyle};
      border-width: ${theme.styles.inputs.base.borderWidth};
      border-color: ${theme.colors.transparent};
      border-radius: ${theme.styles.inputs.base.borderRadius};
      padding: ${theme.space.x1} ${theme.space.x2};
      max-width: ${fullWidth ? undefined : theme.helpers.sizes.x(60)};
      width: ${fullWidth ? '100%' : 'auto'};

      ${InputElement} {
        padding-left: ${theme.space.x1};
        padding-right: ${theme.space.x1};
        width: 100%;

        &::placeholder {
          opacity: 1;
        }
      }
    `, getInputContainerInactiveStyles, getInputContainerHoverStyles, getInputContainerActiveStyles, getInputContainerErrorStyles, getInputContainerDisabledStyles, getInputContainerInactiveOnGrayStyles);
//# sourceMappingURL=input.styles.js.map